import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';

Injectable();

export class Globals {
    domain: string = environment.baseUrl;
    apiEndpoint: string = this.domain + 'api/';
    esEndpoint: string = environment.esUrl;
    radioEndpoint: string = environment.radioUrl;
    shareUrl: string = environment.shareUrl;
}



// WEBPACK FOOTER //
// ./src/app/app.globals.ts